import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { committeeTypeOptions } from '@/module/Nomen/CommitteeType/model/CommitteeTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type CommitteeTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function CommitteeTypeSelectControl<T extends FieldValues>(props: CommitteeTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(committeeTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
